import { render, staticRenderFns } from "./insertProduct.vue?vue&type=template&id=2da1ad73"
import script from "./insertProduct.vue?vue&type=script&lang=js"
export * from "./insertProduct.vue?vue&type=script&lang=js"
import style0 from "./insertProduct.vue?vue&type=style&index=0&id=2da1ad73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports